document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".tab");
  const panels = {
    reg: document.getElementById("panel-reg"),
    model: document.getElementById("panel-model"),
  };
  const submitRegistrationBtn = document.getElementById("submit-registration");
  const submitModelBtn = document.getElementById("submit-model");
  const explorePartsBtn = document.getElementById("explore-parts");
  const regInput = document.querySelector('input[name="keySystemNumber"]');
  const changeVehicleBtn = document.getElementById("change-vehicle");
  const REG_API_URL = "https://small-tooth-4156.d1pubgm.workers.dev/TecdocToCatDLB.jsonEndpoint";

  const configHeaders = {
    "Content-Type": "application/json",
    "Access-Control-Allow-Headers": "Content-Type, Authorization",
  };

  const listMake = [];
  const listModel = [];
  const listEngine = [];
  const selectMake = document.getElementById("select-make");
  const selectModel = document.getElementById("select-model");
  const selectEngine = document.getElementById("select-engine");

  const populateMakeSelect = () => {
    if (!selectMake || listMake.length === 0) return;
    while (selectMake.children.length > 1) {
      selectMake.removeChild(selectMake.lastChild);
    }

    const sortedMakes = listMake.sort((a, b) => {
      const nameA = a.name;
      const nameB = b.name;
      return nameA.localeCompare(nameB);
    });

    sortedMakes.forEach((make) => {
      const option = document.createElement("option");
      const makeName = make.name || make.mfrName || make.value || make.label || JSON.stringify(make);
      option.value = make.id || make.value || makeName;
      option.textContent = makeName;
      selectMake.appendChild(option);
    });
  };

  function convertYYMM(value) {
    if (value === null || value === undefined) return '';

    const str = String(value);

    if (!/^\d{6}$/.test(str)) return '';

    const year = str.slice(0, 4);
    const month = str.slice(4, 6);

    if (month < 1 || month > 12) return '';

    return `${month}/${year}`;
  }

  const populateModelSelect = () => {
    if (!selectModel || listModel.length === 0) return;
    while (selectModel.children.length > 1) {
      selectModel.removeChild(selectModel.lastChild);
    }
    const groupedModels = {};
    listModel.forEach((model) => {
      const modelName = model.name || model.modelName || model.value || model.label || JSON.stringify(model);
      let groupName = "";
      const nameWithoutParentheses = modelName.split(" ");
      groupName = nameWithoutParentheses[0];
      
      if (!groupedModels[groupName]) {
        groupedModels[groupName] = [];
      }
      groupedModels[groupName].push(model);
    });
    
    const sortedGroups = Object.keys(groupedModels).sort((a, b) => {
      const aIsNumber = /^\d+$/.test(a);
      const bIsNumber = /^\d+$/.test(b);
      if (aIsNumber && bIsNumber) {
        return parseInt(a) - parseInt(b);
      }
      if (aIsNumber) return -1;
      if (bIsNumber) return 1;
      return a.localeCompare(b);
    });
    
    sortedGroups.forEach((groupName) => {
      const optgroup = document.createElement("optgroup");
      optgroup.label = groupName;
      
      const sortedModels = groupedModels[groupName].sort((a, b) => {
        const nameA = a.name || a.modelName || a.value || a.label || "";
        const nameB = b.name || b.modelName || b.value || b.label || "";
        return nameA.localeCompare(nameB);
      });
      
      sortedModels.forEach((model) => {
        const option = document.createElement("option");
        const modelName = model.name || model.modelName || model.value || model.label || JSON.stringify(model);
        option.value = model.id || model.value || modelName;
        console.log(convertYYMM(model.beginYearMonth) );
        option.textContent = `${modelName} (${convertYYMM(model.beginYearMonth)} - ${convertYYMM(model.endYearMonth)})`;
        optgroup.appendChild(option);
      });
      
      selectModel.appendChild(optgroup);
    });
  };

  function convertYYYYMM(value) {
    if (!value) return '';

    const str = String(value);

    if (!/^\d{4}-\d{2}$/.test(str)) return '';

    const [year, month] = str.split('-');

    if (month < 1 || month > 12) return '';

    return `${month}/${year}`;
  }

  const populateEngineSelect = () => {
    if (!selectEngine || listEngine.length === 0) return;
    while (selectEngine.children.length > 1) {
      selectEngine.removeChild(selectEngine.lastChild);
    }
    const groupedEngines = {};
    listEngine.forEach((engine) => {
      const fuelType = engine.fuelType || "Other";
      
      if (!groupedEngines[fuelType]) {
        groupedEngines[fuelType] = [];
      }
      groupedEngines[fuelType].push(engine);
    });
    const sortedGroups = Object.keys(groupedEngines).sort((a, b) => {
      return a.localeCompare(b);
    });
    sortedGroups.forEach((fuelType) => {
      const optgroup = document.createElement("optgroup");
      optgroup.label = fuelType;
      const sortedEngines = groupedEngines[fuelType].sort((a, b) => {
        const descA = (a.description || "").toLowerCase();
        const descB = (b.description || "").toLowerCase();
        return descA.localeCompare(descB);
      });

      sortedEngines.forEach((engine) => {
        const option = document.createElement("option");
        const engineCode = engine.engines?.length > 0 ? engine.engines[0].code : "";
        const engineName = `${engine.description} (${engine.horsePowerFrom}CH), ${engine.capacityCC}CC - (${convertYYYYMM(engine.beginYearMonth)} - ${convertYYYYMM(engine.endYearMonth)})`;
        option.value = JSON.stringify(engine);
        option.textContent = engineName;
        optgroup.appendChild(option);
      });
      
      selectEngine.appendChild(optgroup);
    });
  };

  const fetchModelsByMake = async (selectedMakeId) => {
    if (!selectedMakeId || selectedMakeId === "Select Make") return;

    try {
      listModel.length = 0;
      if (selectModel) {
        while (selectModel.children.length > 1) {
          selectModel.removeChild(selectModel.lastChild);
        }
      }
      // Clear engines when make changes
      listEngine.length = 0;
      if (selectEngine) {
        while (selectEngine.children.length > 1) {
          selectEngine.removeChild(selectEngine.lastChild);
        }
      }

      const res = await fetch(REG_API_URL, {
        method: "POST",
        headers: configHeaders,
        body: JSON.stringify({
          getLinkageTargets: {
            linkageTargetCountry: "gb",
            lang: "en",
            linkageTargetType: "P",
            mfrIds: [selectedMakeId],
            includeVehicleModelSeriesFacets: true,
          },
        }),
      });

      if (!res.ok) {
        throw new Error(`Request failed: ${res.status}`);
      }

      const data = await res.json();
      if (data?.vehicleModelSeriesFacets?.counts) {
        listModel.push(...data.vehicleModelSeriesFacets.counts);
        populateModelSelect();
      }
    } catch (error) {
      console.error("Model lookup error:", error);
    }
  };

  const fetchEnginesByMakeAndModel = async (makeId, modelSeriesId) => {
    if (!makeId || makeId === "Select Make" || !modelSeriesId || modelSeriesId === "Select Model") return;

    try {
      listEngine.length = 0;
      if (selectEngine) {
        while (selectEngine.children.length > 1) {
          selectEngine.removeChild(selectEngine.lastChild);
        }
      }

      const res = await fetch(REG_API_URL, {
        method: "POST",
        headers: configHeaders,
        body: JSON.stringify({
          getLinkageTargets: {
            linkageTargetCountry: "gb",
            lang: "en",
            linkageTargetType: "P",
            mfrIds: [makeId],
            vehicleModelSeriesIds: [modelSeriesId],
          },
        }),
      });

      if (!res.ok) {
        throw new Error(`Request failed: ${res.status}`);
      }

      const data = await res.json();
      if (data?.linkageTargets) {
        listEngine.push(...data.linkageTargets);
        setTimeout(() => {
          const _datafilter = getDataFilterFromLocal();
          if(_datafilter){
            const _listEngine = [...listEngine, ...data.linkageTargets]
            if(selectMake) selectMake.value = _datafilter.selectMakeId;
            if(selectModel) selectModel.value = _datafilter.selectModelId;
            if(selectEngine) selectEngine.value = JSON.stringify(_listEngine.find((x) => x?.linkageTargetId == _datafilter.selectEngineId) || {});
          }
        },100)
        populateEngineSelect();
      }
    } catch (error) {
      console.error("Engine lookup error:", error);
    }
  };

  const getDataFilterFromLocal = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const filterid = urlParams.get('filter.v.m.car.ids');
    if(filterid){
      const listFilterIds = JSON.parse(localStorage.getItem('filterId') || '[]');
      return _datafilter = listFilterIds.find((x) => x?.selectEngineId == filterid);
    }
    return null
  }

  (async () => {
    try {
      const vehicle = localStorage.getItem("vehicle");
      if (vehicle) {
        const vehicleData = JSON.parse(vehicle);
        document.getElementById(
          "vehicle-name"
        ).textContent = `${vehicleData.mark} / ${vehicleData.bodyTypeOfVehicle} / ${vehicleData.engineOutputInHP} cc / ${vehicleData.fuel} / ${vehicleData.mfrYear}`;
        document.querySelector(".tab-query")?.classList.add("hidden");
        document.querySelector("#panel-reg-parts")?.classList.add("hidden");
        document.querySelector(".tab-vehicle-info")?.classList.remove("hidden");
        document.querySelector(".tab-vehicle-info-parts")?.classList.remove("hidden");
        regInput.value = "";
      }
      const res = await fetch(REG_API_URL, {
        method: "POST",
        headers: configHeaders,
        body: JSON.stringify({
          getLinkageTargets: {
            linkageTargetCountry: "gb",
            lang: "en",
            linkageTargetType: "P",
            includeMfrFacets: true,
          },
        }),
      });
      if (!res.ok) {
        throw new Error(`Request failed: ${res.status}`);
      }
      const data = await res.json();
      if (data?.mfrFacets?.counts) {
        listMake.push(...data?.mfrFacets?.counts);
        populateMakeSelect();
      }
      const _datafilter = getDataFilterFromLocal();
      if(_datafilter){
        fetchModelsByMake(_datafilter?.selectMakeId);
        fetchEnginesByMakeAndModel(_datafilter?.selectMakeId, _datafilter?.selectModelId);
      }
    } catch (error) {
      console.error("Registration lookup error:", error);
    }
  })();

  if (selectMake) {
    selectMake.addEventListener("change", (e) => {
      const selectedMakeId = e.target.value;
      fetchModelsByMake(selectedMakeId);
    });
  }

  if (selectModel) {
    selectModel.addEventListener("change", (e) => {
      const selectedModelId = e.target.value;
      const selectedMakeId = selectMake?.value;
      fetchEnginesByMakeAndModel(selectedMakeId, selectedModelId);
    });
  }

  if (selectEngine) {
    selectEngine.addEventListener("change", (e) => {
      const selectEngineId = JSON.parse(e?.target?.value || '');
      const currentUrl = new URL(window.location.href);
      const isHome =
        currentUrl.pathname === "/" ||
        currentUrl.pathname === "" ||
        /\/index(\.html)?\/?$/.test(currentUrl.pathname);
      if (!isHome) {
if (typeof FacetFiltersForm !== "undefined") {
  const params = new URLSearchParams(window.location.search);

  params.set(
    "filter.v.m.car.ids",
    selectEngineId?.linkageTargetId
  );

  FacetFiltersForm.renderPage(
    params.toString(),
    null,
    true // update URL
  );
}

      }
      const selectMakeId = selectMake?.value;
      const selectModelId = selectModel?.value;
      const listDataLocal = JSON.parse(localStorage.getItem('filterId') || '[]');
      localStorage.setItem('filterId', JSON.stringify([...listDataLocal, {selectMakeId, selectModelId, selectEngineId: selectEngineId?.linkageTargetId }]))
    });
  }

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      tabs.forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");
      const target = tab.dataset.tab;

      Object.keys(panels).forEach((key) => {
        panels[key].classList.toggle("hidden", key !== target);
      });
    });
  });

  if (changeVehicleBtn) {
    changeVehicleBtn.addEventListener("click", () => {
      localStorage.removeItem("vehicle");
      document.querySelector(".tab-vehicle-info")?.classList.add("hidden");
      document.querySelector(".tab-vehicle-info-parts")?.classList.add("hidden");
      document.querySelector(".tab-query")?.classList.remove("hidden");
      document.querySelector("#panel-reg-parts")?.classList.remove("hidden");
    });
  }

  if (explorePartsBtn) {
    explorePartsBtn.addEventListener("click", () => {
      const vehicle = JSON.parse(localStorage.getItem('vehicle'));
      const getCollection = ALL_COLLECTIONS.find(f => f.title == vehicle?.mark);
      if(getCollection?.url) {
        window.location.href = `${getCollection.url}/?filter.v.m.car.ids=${vehicle.linkageTargetId}`;
      } else {
        window.location.href = "pages/car-parts"
      }
    });
  }

  if (submitModelBtn) {
    submitModelBtn.addEventListener("click", () => {
      const selectedEngine = JSON.parse(selectEngine?.value);
      const vehicle = {
        mark: selectedEngine.mfrName,
        bodyTypeOfVehicle: selectedEngine.bodyStyle,
        engineOutputInHP: selectedEngine.capacityCC,
        engineCapacityCC: selectedEngine.capacityCC,
        fuel: selectedEngine.fuelType,
        // engineOutputInHP: selectedEngine.horsePowerFrom,
        // mfrYear: `${selectedEngine.beginYearMonth.slice(0,4)}–${selectedEngine.endYearMonth.slice(0,4)}`
        mfrYear: `${selectedEngine.beginYearMonth.slice(0, 4)}`,
        linkageTargetId: selectedEngine.linkageTargetId
      };
      localStorage.setItem("vehicle", JSON.stringify(vehicle));
      document.getElementById(
        "vehicle-name"
      ).textContent = `${vehicle.mark} / ${vehicle.bodyTypeOfVehicle} / ${vehicle.engineOutputInHP} cc / ${vehicle.fuel} / ${vehicle.mfrYear}`;
      document.querySelector(".tab-query")?.classList.add("hidden");
      document.querySelector("#panel-reg-parts")?.classList.add("hidden");
      document.querySelector(".tab-vehicle-info")?.classList.remove("hidden");
      document.querySelector(".tab-vehicle-info-parts")?.classList.remove("hidden");
    });
  }

  if (submitRegistrationBtn && regInput) {
    submitRegistrationBtn.addEventListener("click", async (e) => {
      e.preventDefault();
      try {
        let data = null;
        if (regInput && regInput?.value?.trim()) {
          const reg = regInput.value.trim();
          if (!reg) {
            regInput.focus();
            return;
          }
          const res = await fetch(REG_API_URL, {
            method: "POST",
            headers: configHeaders,
            body: JSON.stringify({
              getVehiclesByKeyNumberPlates: {
                country: "gb",
                keySystemNumber: reg,
                keySystemType: 99,
                lang: "en",
                details: true,
              },
            }),
          });

          if (!res.ok) {
            throw new Error(`Request failed: ${res.status}`);
          }
          data = await res.json();
        } else {
          const selectedEngine = JSON.parse(selectEngine?.value);
          const vehicle = {
            mark: selectedEngine.mfrName,
            bodyTypeOfVehicle: selectedEngine.bodyStyle,
            engineOutputInHP: selectedEngine.capacityCC,
            engineCapacityCC: selectedEngine.capacityCC,
            fuel: selectedEngine.fuelType,
            // engineOutputInHP: selectedEngine.horsePowerFrom,
            // mfrYear: `${selectedEngine.beginYearMonth.slice(0,4)}–${selectedEngine.endYearMonth.slice(0,4)}`
            mfrYear: `${selectedEngine.beginYearMonth.slice(0, 4)}`,
            linkageTargetId: selectedEngine.linkageTargetId,

          };
          data = {
            data: {
              array: [
                {
                  vehicleDetails: vehicle,
                },
              ],
            },
          };
        }

        if (data?.data?.array?.length > 0) {
          const vehicle = {
            ...data?.data?.array[0]?.vehicleDetails,
            linkageTargetId: data?.data?.array[0]?.vehicleDetails?.linkageTargetId || data?.data?.array[0]?.carId
          };
          localStorage.setItem("vehicle", JSON.stringify(vehicle));
          document.getElementById(
            "vehicle-name"
          ).textContent = `${vehicle?.mark} / ${vehicle?.bodyTypeOfVehicle} / (${vehicle?.engineOutputInHP}cc) / ${vehicle?.fuel} / ${vehicle?.mfrYear}`;
          document.querySelector(".tab-query")?.classList.add("hidden");
          document.querySelector("#panel-reg-parts")?.classList.add("hidden");
          document.querySelector(".tab-vehicle-info")?.classList.remove("hidden");
          document.querySelector(".tab-vehicle-info-parts")?.classList.remove("hidden");
          regInput.value = "";
        }
        console.log("Registration lookup success:", data);
      } catch (err) {
        console.error("Registration lookup error:", err);
      }
    });
  }

  // Selects Accordion Toggle
  const selectsToggle = document.getElementById("selects-toggle");
  const selectsAccordion = document.querySelector(".selects-accordion");
  
  if (selectsToggle && selectsAccordion) {
    selectsToggle.addEventListener("click", () => {
      selectsAccordion.classList.toggle("expanded");
    });
  }


  const closeBtn = document.getElementById("icon-close-filter-svg");

  if (closeBtn) {
    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();

      // 1) Reset value về option đầu (placeholder)
      if (selectMake) selectMake.selectedIndex = 0;
      if (selectModel) selectModel.selectedIndex = 0;
      if (selectEngine) selectEngine.selectedIndex = 0;

      // 2) Clear data arrays
      listModel.length = 0;
      listEngine.length = 0;

      // 3) Clear option UI của Model/Engine (giữ lại option đầu)
      if (selectModel) {
        while (selectModel.children.length > 1) selectModel.removeChild(selectModel.lastChild);
      }
      if (selectEngine) {
        while (selectEngine.children.length > 1) selectEngine.removeChild(selectEngine.lastChild);
      }

      // (tuỳ bạn) clear luôn local đang nhớ lựa chọn
      // localStorage.removeItem("filterId");
      // localStorage.removeItem("vehicle");
    });
  }

});

document.addEventListener("click", function (e) {
  const link = e.target.closest("a[href]");
  if (!link) return;

  const href = link.getAttribute("href");

  // 1️⃣ Chỉ bắt link collection
  if (!href.startsWith("/collections")) return;

  const vehicle = JSON.parse(localStorage.getItem("vehicle"));
  if (!vehicle?.linkageTargetId) return;

  const url = new URL(href, window.location.origin);

  // 2️⃣ Nếu link đã có filter → cho đi bình thường
  if (url.searchParams.has("filter.v.m.car.ids")) return;

  // 3️⃣ Chặn navigation mặc định
  e.preventDefault();

  // 4️⃣ Gắn filter
  url.searchParams.set(
    "filter.v.m.car.ids",
    vehicle.linkageTargetId
  );

  // 5️⃣ Điều hướng → load 1 lần duy nhất
  window.location.href = url.toString();
});


/**-----------------------------js to app--------- */
document.addEventListener("DOMContentLoaded", function () {
    const vrmInput = document.getElementById('vrm-input');

    if (vrmInput) {
        // Xoá autofocus nếu có
        vrmInput.removeAttribute('autofocus');

        // Set placeholder ban đầu
        vrmInput.placeholder = 'ENTER REG';

        // Lưu placeholder gốc
        var originalPlaceholder = vrmInput.placeholder;

        // Ẩn placeholder khi focus
        vrmInput.addEventListener('focus', function () {
            vrmInput.placeholder = '';
        });

        // Khôi phục placeholder khi blur mà chưa nhập gì
        vrmInput.addEventListener('blur', function () {
            if (!vrmInput.value) {
                vrmInput.placeholder = originalPlaceholder;
            }
        });

        // Nếu script khác vẫn cố focus, mình blur lại sau một nhịp
        setTimeout(function () {
            vrmInput.blur();
        }, 200);
    }

    const tabVrm = document.getElementById('tab-vrm');
    if (tabVrm) {
        tabVrm.textContent = 'By Registration';
    }

    const tabSelection = document.getElementById('tab-selection');
    if (tabSelection) {
        tabSelection.textContent = 'By Model';
    }

    document.querySelectorAll('.single-banner button[type="submit"]').forEach(btn => {
        btn.textContent = 'Find Parts';
    });

    if (window.location.pathname !== '/') {
        document.querySelectorAll('.vehicle-filter-wrapper').forEach(wrap => {
            wrap.classList.add('custom-pc');
        });
    }
});